<template>
	<div>
		<myheader :backFlag="true" headTitle="电子签名"></myheader>
		<div class="main">
			<div style="width:40%;margin:0 auto;" :style="{ display:hasSignature?'none':'block' }">
				<div class="text14 textcolor333" style="width:100%; margin-top: 1rem;text-align: center;">您还没有创建电子签名
				</div>
				<Button class="all_button18 text14 bmain_active" style="width:60%;margin:1rem 20% 0 20% "
					@click="showBottom=true">创建签名</Button>
			</div>
			<div v-if="hasSignature" class="esignature_content">
				<div class="signature">
					<div style="height:2rem;">
						<span class="text14 textcolor333"
							style="line-height: 2rem;margin-left: .5rem;">个人签名&nbsp;-&nbsp;</span>
						<span class="text14 textcolor333" style="line-height: 2rem;"
							:style="{color:textcolor}">{{signatureStatus}}</span>
						<span v-if="userInfo.signature && userInfo.signature.status === 3" style="line-height: 2rem;"
							class="text10 textcolorNopass">&nbsp;:&nbsp;{{userInfo.signature.auditMemo}}</span>
						<img v-if="isEdit" src="@/assets/images/menu.svg" style="width:1rem;margin:.5rem;float:right"
							@click="showBottom=true" />
					</div>
					<div style="width: 100%; text-align: center;padding-bottom: 1rem;">
						<img :src="'data:image/png;base64,'+signatureFileBase64"
							style="width:11rem;height:4rem;margin: 0.5rem;object-fit: contain;">
					</div>
				</div>
			</div>
			<van-popup v-model:show="showBottom" :overlay="false" position="bottom">
				<div class="signatureTool">
					<div class="horizontal_line"></div>
					<!-- <div v-if="!isEdit" class="text text14 textcolor999" @click="isEdit=true">编&nbsp;辑</div> -->
					<div v-if="hasSignature">
						<div class="text text14 textcolor666 backgroundC_white bwhite_ative" @click="deleteSignature()">
							删&nbsp;除</div>
						<div class="horizontal_line"></div>
					</div>
					<div v-else>
						<div class="text text14 textcolor666 backgroundC_white bwhite_ative" @click="write()">手写签名</div>
						<div class="horizontal_line"></div>
						<div class="text text14 textcolor666 backgroundC_white bwhite_ative" @click="jump()">上传签名照片
						</div>
						<div class="horizontal_line"></div>
						<div class="text text14 textcolor666 backgroundC_white bwhite_ative" @click="create()">一键生成签名
						</div>
						<div class="horizontal_line"></div>
					</div>
					<div style="height:.5rem;background-color: #ededed;"></div>
					<div class="horizontal_line"></div>
					<div class="all_height_line24  text text14 textcolor999" @click="showBottom = false">取&nbsp;消</div>
				</div>
			</van-popup>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import {
		Dialog
	} from 'vant';
	export default {
		data() {
			return {
				//是否有签名
				hasSignature: false,
				//审核中不能修改
				isEdit: false,
				showBottom: false,
				//个人信息
				userInfo: '',
				//个人签名base64
				signatureFileBase64: '',
				//状态颜色
				textcolor: '#333',
				//状态文字
				signatureStatus: '',
			}
		},
		methods: {
			//上传
			jump() {
				this.$router.push({
					path: '/uploadsignature'
				})
			},
			//生成
			create() {
				this.$router.push({
					path: '/createsignature'
				})
			},
			//手写
			write() {
				this.$router.push({
					path: '/writesignaturepad'
				})
			},
			//编辑
			editSignature() {
				if (this.signatureFileBase64) {
					this.$Toast("请先删除签名！");
					return
				}
				this.isEdit = true
			},
			//删除签名
			deleteSignature() {
				var that = this
				this.showBottom = false
				if (this.signatureFileBase64) {
					Dialog.confirm({
							title: '提示',
							message: '确定删除当前签名？',
							confirmButtonText: '确定',
							confirmButtonColor: '#0277FC'
						})
						.then(() => {
							that.$store.dispatch(that.$LoadShow, true)
							that.$post('/my/api/removeSignature?signatureId=' + that.userInfo.signature.signatureId)
								.then((res) => {
									that.$store.dispatch(that.$LoadShow, false)
									if (res.success) {
										that.$Toast("删除成功！");
										that.signatureFileBase64 = ''
										that.hasSignature = false
										that.getUserInfo()
									} else {
										that.$Toast(res.message || "删除失败！");
									}
								});
						})
						.catch(() => {
							// on cancel
						});
				} else {
					this.$Toast("您还没有个人签名！");
				}
			},
			//获取个人签名
			getSignatureFileBase64() {
				this.$store.dispatch(this.$LoadShow, true)
				this.$post('/staff/api/getSignetInfo')
					.then((res) => {
						this.$store.dispatch(this.$LoadShow, false)
						if (res.success && res.data) {
							this.signatureFileBase64 = res.data.signatureFileBase64
							this.hasSignature = this.Tool.isNoEmpty(this.signatureFileBase64)
						}
					})
			},
			//获取个人信息
			getUserInfo() {
				this.$store.dispatch(this.$LoadShow, true)
				this.$post('/my/api/getDetailForMobile').then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success && res.data) {
						this.userInfo = res.data
						if (this.userInfo.signature) {
							this.signatureFileBase64 = this.userInfo.signature.fileData
							this.hasSignature = this.Tool.isNoEmpty(this.signatureFileBase64)
							this.isEdit = this.userInfo.signature.status != 1
							switch (this.userInfo.signature.status) {
								case 1:
									this.signatureStatus = '审核中'
									this.textcolor = '#F59A23'
									break;
								case 2:
									this.signatureStatus = '使用中'
									this.textcolor = '#70B603'
									break;
								case 3:
									this.signatureStatus = '未通过'
									this.textcolor = '#D9001B'
									break;
							}
						} else {
							this.hasSignature = false
						}
					} else {
						this.$Toast(res.message || "获取信息失败！");
						this.userInfo = ''
						this.hasSignature = false
					}
				});
			}
		},
		mounted() {
			this.getUserInfo()
		},
		//#70B603  #F59A23  #D9001B
	}
</script>

<style scoped lang="scss">
	@import "../../../styles/global.css";

	.main {
		position: relative;
		padding-top: 4rem;

		.esignature_content {
			padding: .5rem;

			.signature {
				width: 100%;
				border-radius: .3rem;
				background-color: white;
			}
		}

		.signatureTool {
			.text {
				width: 100%;
				height: 2rem;
				line-height: 2rem;
				text-align: center;
			}
		}
	}
</style>